import React, {FC} from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import {useInitializeServices} from "../features/services/redux/services.hook";
import {ServicesStep} from "./steps/ServicesStep";
import {AddressStep} from "./steps/AddressStep";
import {useAppDispatch, useAppSelector} from "../redux/redux.hook";
import {selectAllSuggestedAvailabilities} from "./redux/suggestedAvailibilities.slice";
import {bookSuggestedAvailabilityThunk, getSuggestedAvailabilitiesThunk} from "./redux/suggestedAvailabilities.thunk";
import {SuggestedAvailabilitiesStep} from "./steps/SuggestedAvailabilitiesStep";
import {ClientDataStep} from "./steps/ClientDataStep";
import {
    Checkbox, Collapse, Container,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    LinearProgress,
    Link,
    Typography, useMediaQuery
} from "@material-ui/core";
import {OrderEngineStepActions} from "./steps/OrderEngineStepActions";
import {PersonalMessageStep} from "./steps/PersonalMessageStep";
import {getEmptyOrderAddress, useOrderAddressFormState} from "./orderAddressState.hook";
import {SummaryStep} from "./steps/SummaryStep";
import {EndStep} from "./steps/EndStep";
import {OrderEngineHeader} from "./header/OrderEngineHeader";
import {OrderEngineFooter} from "./OrderEngineFooter";
import {Theme} from "@material-ui/core/styles";
import arbeiterBild from "./arbeiterBild.png";

const FindAvailabilitiesForm: FC = () => {
    const dispatch = useAppDispatch();

    const bottomAnchorRef = React.useRef<HTMLDivElement>(null);

    const [activeStepIndex, setActiveStepIndex] = React.useState(0);
    const [servicesIds, setServiceIds] = React.useState<string[]>([]);

    const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

    const [
        serviceAddressData,
        setServiceAddressPlace,
        setServiceAddressName
    ] = useOrderAddressFormState(getEmptyOrderAddress());

    const [
        invoiceAddressData,
        setInvoiceAddressPlace,
        setInvoiceAddressName
    ] = useOrderAddressFormState();

    const [clientEmail, setClientEmail] = React.useState("");

    const [timeRange, setTimeRange] = React.useState<{ estimatedFrom: number; estimatedTo: number }>();
    const [selectedWorker, setSelectedWorker] = React.useState({name: "", workerId: ""});
    const [agbsChecked, setAgbsChecked] = React.useState(false);
    const [priceInfoChecked, setPriceInfoChecked] = React.useState(false);
    const [personalMessage, setPersonalMessage] = React.useState("");

    console.log(timeRange);

    const goNext = () => setActiveStepIndex(p => p + 1);
    const goBack = () => setActiveStepIndex(p => p - 1);

    const [completed, setCompleted] = React.useState(false);

    const suggestedAvailabilities = useAppSelector(selectAllSuggestedAvailabilities);
    const loading = useAppSelector((state) => state.suggestedAvailabilities.loading);

    const fetchSuggestedAvailabilities = React.useCallback((from: number, to: number) =>
        dispatch(getSuggestedAvailabilitiesThunk({
            servicesIds,
            addressCoordinates: {
                lat: serviceAddressData?.address?.lat ?? 0,
                long: serviceAddressData?.address?.long ?? 0
            },
            timeRange: {from, to}
        })), [dispatch, serviceAddressData?.address?.lat, serviceAddressData?.address?.long, servicesIds])

    return (
        <React.Fragment>
            <OrderEngineHeader
                isDesktop={isDesktop}
                showImage={activeStepIndex === 0}
            />
            {completed
                ? <EndStep isDesktop={isDesktop}/>
                : (
                    <Container>
                        <Collapse in={activeStepIndex === 0}>
                            <div>
                                <img
                                    alt="Arbeiter Bild"
                                    src={arbeiterBild}
                                    width={"100%"}
                                />
                                <Typography
                                    variant={isDesktop ? "h4" : "body1"}
                                    style={{
                                        fontWeight: 600,
                                        paddingLeft: 24,
                                        marginTop: 16,
                                        /*marginBottom: 8*/
                                    }}
                                    color={"secondary"}
                                >
                                    Buchen Sie jetzt ihre
                                    <Typography
                                        variant="inherit"
                                        color="primary"
                                    >
                                        {" "}Gartenhilfe
                                    </Typography>
                                </Typography>
                            </div>
                        </Collapse>
                        <Stepper activeStep={activeStepIndex} orientation="vertical">
                            <Step>
                                <StepLabel>
                                    Dienstleistungen auswählen
                                </StepLabel>
                                <StepContent>
                                    <ServicesStep
                                        initialValue={servicesIds}
                                        onNext={(value) => {
                                            setServiceIds(value);
                                            goNext();
                                        }}
                                    />
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel>
                                    Auftragsadresse eintragen
                                </StepLabel>
                                <StepContent>
                                    <AddressStep
                                        initialValue={serviceAddressData?.address}
                                        onNext={(value) => {
                                            setServiceAddressPlace(value);
                                            /*handleGetSuggestedAvailabilities(value);*/
                                            goNext();
                                        }}
                                        onBack={goBack}
                                    />
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel>Termin finden</StepLabel>
                                <StepContent>
                                    <SuggestedAvailabilitiesStep
                                        isDesktop={isDesktop}
                                        fetchSuggestedAvailabilities={fetchSuggestedAvailabilities}
                                        suggestAvailabilities={suggestedAvailabilities}
                                        loading={loading}
                                        servicesIds={servicesIds}
                                        onBack={goBack}
                                        onNext={(v) => {
                                            setTimeRange(v.timeRange);
                                            setSelectedWorker({
                                                workerId: v.worker.workerId,
                                                name: v.worker.workerName
                                            })
                                            goNext();
                                            /*setTimeout(() => {
                                                if (bottomAnchorRef.current) {
                                                    console.log("scroll")
                                                    bottomAnchorRef.current.scrollIntoView({behavior: "smooth"})
                                                }
                                            }, 500);*/
                                        }}
                                    />
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel>Stammdaten eintragen</StepLabel>
                                <StepContent>
                                    {serviceAddressData && (
                                        <ClientDataStep
                                            isDesktop={isDesktop}
                                            initialValue={{
                                                serviceAddress: serviceAddressData,
                                                invoiceAddress: invoiceAddressData,
                                                email: clientEmail
                                            }}
                                            estimatedFrom={timeRange?.estimatedFrom ?? 0}
                                            estimatedTo={timeRange?.estimatedTo ?? 0}
                                            onNext={(c) => {
                                                setClientEmail(c.email);
                                                setServiceAddressName(c.serviceAddress.name, c.serviceAddress.phone);
                                                if (c.invoiceAddress) {
                                                    setInvoiceAddressPlace(c.invoiceAddress.address);
                                                    setInvoiceAddressName(c.invoiceAddress.name, c.invoiceAddress.phone);
                                                }
                                                goNext();
                                            }}
                                            onBack={goBack}
                                        />)}
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel>Persönliche Mitteilung</StepLabel>
                                <StepContent>
                                    <PersonalMessageStep
                                        initialValue={personalMessage}
                                        workerName={selectedWorker.name}
                                        onNext={(message) => {
                                            setPersonalMessage(message);
                                            goNext();
                                        }}
                                        onBack={goBack}
                                    />
                                </StepContent>
                            </Step>
                            <Step>
                                <StepLabel>Zusammenfassung</StepLabel>
                                <StepContent>
                                    <Dialog open={loading}>
                                        <DialogTitle>
                                            Buchung wird bearbeitet
                                        </DialogTitle>
                                        <DialogContent>
                                            <LinearProgress style={{marginBottom: 16}}/>
                                            <DialogContentText>
                                                Ihre Buchung wird überprüft und eingetragen
                                            </DialogContentText>
                                        </DialogContent>
                                    </Dialog>
                                    {serviceAddressData && timeRange &&
                                    <SummaryStep
                                        isDesktop={isDesktop}
                                        onSubmit={() => {
                                        }}
                                        clientEmail={clientEmail}
                                        workerName={selectedWorker.name}
                                        servicesIds={servicesIds}
                                        timeRange={timeRange}
                                        serviceAddress={serviceAddressData}
                                        invoiceAddress={invoiceAddressData}
                                    />}
                                    <div style={{marginTop: 16}}>
                                        <FormGroup aria-label="position">
                                            <FormControlLabel
                                                value="end"
                                                control={<Checkbox color="primary" checked={agbsChecked}
                                                                   onChange={() => setAgbsChecked(p => !p)}/>}
                                                label="Ich habe verstanden, dass die Gartenhilfe keine Gartengeräte mitbringen
                                        wird und sich nicht um die Entsorgung der anfallenden Gartenabfälle
                                        kümmern kann.  Es werden mindestens zwei volle Stunden abgerechnet
                                        mit 23 € (inkl. Steuer) pro Stunde. An- und Abfahrt werden nicht berechnet."
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                value="end"
                                                control={<Checkbox color="primary" checked={priceInfoChecked}
                                                                   onChange={() => setPriceInfoChecked(p => !p)}/>}
                                                label={<Typography variant="inherit">
                                                    Ich habe die <Link target="_blank"
                                                                       href="https://www.diefleissigenenkel.de/datenschutzerklaerung/">Datenschutzerklärung</Link> zur
                                                    Kenntnis genommen. Ich stimme zu, dass meine Angaben zur
                                                    Kontaktaufnahme und
                                                    für Rückfragen gespeichert werden.
                                                </Typography>}
                                                labelPlacement="end"
                                            />
                                        </FormGroup>
                                    </div>
                                    <OrderEngineStepActions
                                        lastStep={true}
                                        onClickBack={goBack}
                                        onClickNext={
                                            agbsChecked && priceInfoChecked ? () => {
                                                if (serviceAddressData && timeRange) {
                                                    dispatch(bookSuggestedAvailabilityThunk({
                                                        servicesIds,
                                                        email: clientEmail,
                                                        serviceAddress: serviceAddressData,
                                                        invoiceAddress: invoiceAddressData,
                                                        estimatedFrom: timeRange.estimatedFrom,
                                                        estimatedTo: timeRange.estimatedTo,
                                                        extraInfo: personalMessage,
                                                        workerId: selectedWorker.workerId
                                                    })).then(() => {
                                                        setCompleted(true);
                                                    }).catch(() => {
                                                    })
                                                }
                                            } : undefined
                                        }/>
                                </StepContent>
                            </Step>
                        </Stepper>
                    </Container>
                )
            }
            <div ref={bottomAnchorRef}/>
            {isDesktop && <OrderEngineFooter hideFooter={activeStepIndex > 1}/>}
        </React.Fragment>
    );
}

export default function OrderEngine() {
    useInitializeServices();
    return (<FindAvailabilitiesForm/>);
}
